import { render, staticRenderFns } from "./DialogPetitionRequest.vue?vue&type=template&id=d5f7a408&"
import script from "./DialogPetitionRequest.vue?vue&type=script&lang=js&"
export * from "./DialogPetitionRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports